import HelpHomeTemplate from "./HelpHomeTemplate";

export default HelpHomeTemplate;
